<template>
  <div class="pt-15 animated fadeIn masterGLaccount staticPageInner equipmentList bgV2">
    <div class="boxShadow setBorderRadius heig-frame-equipment-group">
      <b-row no-gutters>
        <b-col md="12" class="heig-frame-child">
          <gofix-card title=" ">
            <template slot="gofixCard:right_header">
              <div class="d-flex justify-content-end align-items-center">
                <gofix-button @click="invokePayment" :loading="loading" label="Invoke"></gofix-button>
              </div>
            </template>
            <b-row>
              <b-col md="4">
                <gofix-form-input label="Transaction Reference" v-model="payment.transactionReference" required
                                  showIconRequired></gofix-form-input>
              </b-col>
              <b-col md="4">
                <gofix-form-dropdown
                    label="Purpose Code"
                    :clearable="false"
                    v-model="payment.purposeCode"
                    :reduce="option => option.value"
                    required showIconRequired
                    :options="purposeCodeData">
                </gofix-form-dropdown>
              </b-col>
              <b-col md="4">
                <gofix-form-input label="End To End Id" v-model="payment.endToEndId" required
                                  showIconRequired></gofix-form-input>
              </b-col>
              <b-col md="4">
                <gofix-form-input label="Currency" v-model="payment.Currency" required
                                  showIconRequired></gofix-form-input>
              </b-col>
              <b-col md="4">
                <gofix-form-input label="Amount" v-model="payment.Amount" required showIconRequired></gofix-form-input>
              </b-col>
            </b-row>
          </gofix-card>
          <gofix-card title="Originator Detail">
            <b-row>
              <b-col md="4">
                <gofix-form-dropdown
                    label="Originator"
                    vLabel="client_name"
                    :filterable="false"
                    :clearable="false"
                    v-model="originatorSelected"
                    :options="originator">
                  <template slot="gofixInput:dropdown:option" slot-scope="option">
                    <div class="uob-originator-option">
                      <h3>{{option.client_name}}</h3>
                      <p>UEN: {{option.uen}}</p>
                      <p>Account number: {{option.account_number}}</p>
                    </div>
                  </template>
                </gofix-form-dropdown>
              </b-col>
            </b-row>
          </gofix-card>
          <gofix-card title="Receiver Details">
            <b-row>
              <b-col md="4">
                <gofix-form-dropdown
                    label="Receiver Type"
                    :filterable="false"
                    :clearable="false"
                    v-model="payment.receiverType"
                    :options="['Payment','PayNow']">
                </gofix-form-dropdown>
              </b-col>
            </b-row>
            <b-row v-if="payment.receiverType === 'Payment'">
              <b-col md="4">
                <gofix-form-input label="Account Number" v-model="payment.receiverAccountNumber" required
                                  showIconRequired></gofix-form-input>
              </b-col>
              <b-col md="4">
                <gofix-form-input label="Account Currency" v-model="payment.receiverAccountCurrency" required
                                  showIconRequired></gofix-form-input>
              </b-col>
              <b-col md="4">
                <gofix-form-dropdown
                    label="Account Type"
                    :filterable="false"
                    v-model="payment.receiverAccountType"
                    :options="['D','S']">
                </gofix-form-dropdown>
              </b-col>
              <b-col md="4">
                <gofix-form-input label="Account Name" v-model="payment.receiverAccountName" required
                                  showIconRequired></gofix-form-input>
              </b-col>
              <b-col md="4">
                <gofix-form-input label="bic" v-model="payment.bic" required showIconRequired></gofix-form-input>
              </b-col>
            </b-row>
            <b-row v-if="payment.receiverType === 'PayNow'">
              <b-col md="4">
                <gofix-form-dropdown
                    label="Proxy Type"
                    :filterable="true"
                    :required="true"
                    v-model="payment.proxyType"
                    showIconRequired
                    :options="['MSISDN','NRIC','UEN','VPA']">
                </gofix-form-dropdown>
              </b-col>
              <b-col md="4">
                <gofix-form-input label="Proxy Value" v-model="payment.proxyValue" required
                                  showIconRequired></gofix-form-input>
              </b-col>
            </b-row>
          </gofix-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'uob_payment',
  components: {},
  data() {
    return {
      loading: false,
      payment: {
        transactionReference: null,
        purposeCode: null,
        endToEndId: null,
        receiverType: "Payment",
        receiverAccountNumber: null,
        receiverAccountCurrency: null,
        receiverAccountType: null,
        receiverAccountName: null,
        originatorAccountNumber: process.env.VUE_APP_UOB_API_URL === 'https://api-uat.uob.com.sg' ?  "1013366743" : "9253437371",
        originatorAccountCurrency: "SGD",
        originatorAccountType: "D",
        bic: null,
        proxyValue: null,
        proxyType: null,
        Currency: "SGD",
        Amount: null
      },
      originator:process.env.VUE_APP_UOB_API_URL === 'https://api-uat.uob.com.sg' ? [
        {
          client_name:"E M Services Ptd Ltd",
          uen:"198803538N",
          account_number:"1013366743",
          account_currency:"SGD",
          account_type:"D",
        },
        {
          client_name:"E M REAL ESTATE PRIVATE LIMITED",
          uen:"200100165G",
          account_number:"1013108884",
          account_currency:"SGD",
          account_type:"D",
        }
      ]:[
        {
          client_name:"E M SERVICES PRIVATE LIMITED",
          uen:"198803538N",
          account_number:"9253437371",
          account_currency:"SGD",
          account_type:"D",
        }
      ],
      originatorSelected: process.env.VUE_APP_UOB_API_URL === 'https://api-uat.uob.com.sg' ? {
        client_name:"E M Services Ptd Ltd",
        uen:"198803538N",
        account_number:"1013366743",
        account_currency:"SGD",
        account_type:"D",
      } : {
        client_name:"E M SERVICES PRIVATE LIMITED",
        uen:"198803538N",
        account_number:"9253437371",
        account_currency:"SGD",
        account_type:"D",
      },
      purposeCodeData: [
        {value: "BEXP", label: "Business Expenses"},
        {value: "BONU", label: "Bonus Payment"},
        {value: "CBTV", label: "Cable TV Bill"},
        {value: "CCRD", label: "Credit Card Payment"},
        {value: "CHAR", label: "Charity Payment"},
        {value: "COLL", label: "Collection Payment"},
        {value: "COMM", label: "Commission"},
        {value: "CPKC", label: "Carpark Charges"},
        {value: "CSDB", label: "Cash Disbursement"},
        {value: "DCRD", label: "Debit Card Paymen"},
        {value: "DIVD", label: "Dividend"},
        {value: "DNTS", label: "Dental Services"},
        {value: "EDUC", label: "Education"},
        {value: "FCPM", label: "Payment of Fees and Charges"},
        {value: "FWLV", label: "Foreign Worker Levy"},
        {value: "GDDS", label: "Purchase Sale Of Goods"},
        {value: "GOVI", label: "Government Insurance"},
        {value: "GSTX", label: "Goods & Services Tax"},
        {value: "HSPC", label: "Hospital Care"},
        {value: "IHRP", label: "Instalment Hire Purchase Agreement"},
        {value: "INSU", label: "Insurance Premium"},
        {value: "INTC", label: "Intra Company Payment"},
        {value: "INTE", label: "Interest"},
        {value: "INVS", label: "Investment & Securities"},
        {value: "IVPT", label: "Invoice Payment"},
        {value: "LOAN", label: "Loan"},
        {value: "MDCS", label: "Medical Services"},
        {value: "NITX", label: "Net Income Tax"},
        {value: "OTHR", label: "Other"},
        {value: "PHON", label: "Telephone Bil"},
        {value: "PTXP", label: "Property Tax"},
        {value: "RDTX", label: "Road Tax"},
        {value: "REBT", label: "Rebate"},
        {value: "REFU", label: "Refund"},
        {value: "RENT", label: "Rent"},
        {value: "SALA", label: "Salary Payment"},
        {value: "STDY", label: "Study"},
        {value: "SUPP", label: "Supplier Payment"},
        {value: "TAXS", label: "Tax Payment"},
        {value: "TBIL", label: "Telco Bill"},
        {value: "TCSC", label: "Town Council Service Charges"},
        {value: "TRAD", label: "Trade Services"},
        {value: "TREA", label: "Treasury Payment"},
        {value: "TRPT", label: "Transport"},
        {value: "UBIL", label: "Utilities"},
        {value: "WHLD", label: "With Holding"}
      ]
    }
  },
  computed: {},
  watch: {
    originatorSelected: function(val){
      this.payment.originatorAccountNumber = val.account_number;
      this.payment.originatorAccountCurrency = val.account_currency;
      this.payment.originatorAccountType = val.account_type;
    }
  },
  async created() {
  },
  methods: {
    invokePayment() {
      //Check required data
      if (!this.payment.transactionReference
          || !this.payment.purposeCode
          || !this.payment.endToEndId
          || !this.payment.Currency
          || !this.payment.Amount
      ) {
        return this.$bvToast.toast("Please fill all required fields", {
          title: `Notification`,
          autoHideDelay: 3000,
          variant: 'danger',
          solid: true
        })
      }
      if (this.payment.receiverType === 'PayNow') {
        if (!this.payment.proxyValue
            || !this.payment.proxyType
        ) {
          return this.$bvToast.toast("Please fill all required fields", {
            title: `Notification`,
            autoHideDelay: 3000,
            variant: 'danger',
            solid: true
          })
        }
      } else {
        if (!this.payment.receiverAccountNumber
            || !this.payment.receiverAccountCurrency
            || !this.payment.receiverAccountName
            || !this.payment.bic
        ) {
          return this.$bvToast.toast("Please fill all required fields", {
            title: `Notification`,
            autoHideDelay: 3000,
            variant: 'danger',
            solid: true
          })
        }
      }

      //Invoke payment
      this.loading = true;
      this.$store.dispatch("UOBController/invokePayment", this.payment)
          .then(response => {
            this.loading = false;
            this.$bvToast.toast("Payment success. Please check notification list", {
              title: `Notification`,
              autoHideDelay: 3000,
              variant: 'success',
              solid: true
            })
          })
          .catch(err => {
            this.loading = false;
            if (err.response.data.error.message.description) {
              return this.$bvToast.toast(err.response.data.error.message.description, {
                title: `Notification`,
                autoHideDelay: 3000,
                variant: 'danger',
                solid: true
              })
            }
            if (err.response.data.error.message.transactionStatus.description) {
              return this.$bvToast.toast(err.response.data.error.message.transactionStatus.description, {
                title: `Notification`,
                autoHideDelay: 3000,
                variant: 'danger',
                solid: true
              })
            }
          })
    },
  }
}
</script>
